import { classNames } from "../../../lib/classNames"

function PopoverListEmpty() {
  return (
    <li
      className={classNames(
        "flex items-center",
        "text-v2-foreground-default text-sm",
        "bg-v2-background-elevation",
        "px-3 py-2"
      )}
    >
      No results found
    </li>
  )
}

export default PopoverListEmpty
